import * as React from "react";

function IconWarning(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 20 20" fill="none" {...props}>
      <path
        d="M10 1.667a8.333 8.333 0 100 16.666 8.333 8.333 0 000-16.666zm0 12.5a.833.833 0 11-.001-1.666.833.833 0 010 1.666zm.833-3.334a.833.833 0 01-1.667 0V6.667a.833.833 0 111.667 0v4.166z"
        fill="#FF4242"
      />
    </svg>
  );
}

const MemoIconWarning = React.memo(IconWarning);
export default MemoIconWarning;
